import React from 'react';

export class HalfHalfSection extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  render () {
    return (
      <section className={ `halfhalfsection background-${this.props.category || ''} ${this.props.reverseOrder && 'halfhalfsection--reverse-mobile'}`}>
        <div className="container">
          <div className="halfhalfsection__left">
            { this.props.children[0] }
          </div>
          <div className="halfhalfsection__right">
            { this.props.children[1] }
          </div>
        </div>
      </section>
    );
  }
}
